<svg width="13" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.375 11.5v2h-10v-2h-1v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2h-1Zm0-5-.7-.7-3.8 3.8V.5h-1v9.1l-3.8-3.8-.7.7 5 5 5-5Z"
    fill="currentColor"
  />
</svg>
